'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _util = require('./util');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var query = function query(name) {
  var initialParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    name: name,
    initialParams: initialParams,

    init: function init() {
      return { name: name, params: initialParams };
    },

    make: function make(_ref) {
      var queries = _ref.queries,
          requests = _ref.requests,
          update = _ref.update;
      var _queries$name = queries[name],
          query = _queries$name === undefined ? { loading: false, loaded: false, results: null, params: initialParams } : _queries$name;

      var key = (0, _util.serialize)(name, query.params);
      var _requests$key = requests[key],
          request = _requests$key === undefined ? {} : _requests$key;


      var _update = function _update(newParams) {
        return update(name, _extends({}, query.params, newParams));
      };
      var reset = function reset() {
        return update(name, _extends({}, initialParams));
      };
      var toggle = function toggle(key) {
        return _update(_defineProperty({}, key, !query.params[key]));
      };
      var increment = function increment(key) {
        return _update(_defineProperty({}, key, query.params[key] + 1));
      };
      var decrement = function decrement(key) {
        return _update(_defineProperty({}, key, query.params[key] - 1));
      };

      return _extends({
        // Defaults ...
        loading: false,
        loaded: false,
        results: null,
        params: initialParams

      }, query, {

        // Actions...
        update: _update,
        toggle: toggle,
        increment: increment,
        decrement: decrement,
        reset: reset
      });
    }
  };
};

query.loadMore = function (name) {
  var initialParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var q = query(name, initialParams);

  return _extends({}, q, {
    init: function init() {
      return _extends({}, q.init(), { handler: 'loadMore' });
    },
    make: function make(_ref2) {
      var queries = _ref2.queries,
          requests = _ref2.requests,
          update = _ref2.update;

      var _update = function _update(name, newParams) {
        return update(name, _extends({}, newParams, { page: 1 }));
      };
      var res = q.make({ queries: queries, requests: requests, update: _update });
      var _res$pagination = res.pagination;
      _res$pagination = _res$pagination === undefined ? {} : _res$pagination;
      var _res$pagination$curre = _res$pagination.current_page,
          current_page = _res$pagination$curre === undefined ? 1 : _res$pagination$curre,
          _res$pagination$last_ = _res$pagination.last_page,
          last_page = _res$pagination$last_ === undefined ? 1 : _res$pagination$last_;


      return _extends({}, res, {
        canLoadMore: current_page < last_page,
        loadMore: function loadMore() {
          return update(name, _extends({}, res.params, { page: res.params.page + 1 }));
        }
      });
    }
  });
};

exports.default = query;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@jump/pages/lib/query.js
// module id = 261
// module chunks = 0